export const typeface = {
  primary: "Lato, sans-serif",
  baseSize: "16px",
};
export const colors = {
  black: "#000000",
  gray1: "#151619",
  gray4: "#40424c",
  gray6: "#6a6e7e",
  grayA: "#afb0b6", // Disabled button and input states
  grayE: "#e1e2e5", // Borders
  grayF6: "#f6f6f7", // Hovered row
  grayF: "#fbfbfc",
  white: "#ffffff",

  blue1: "#13194b", // Selected sidebar btn bg
  blue2: "#262c64", // Sidebar, toast bg
  blue3: "#323A86", // Sidebar, toast bg
  blue7: "#0e8de8", // Selected btn bg, links
  blueA: "#a1c5fb", // Focused input & btn
  blueE: "#eef7fd", // Selected row
  blueF: "#f4f5ff", // Button hover bg
  blueT: "#3264fa", // Blue text

  cream: "#f6f3eb",
  forestGreen: "#073937",
  greenDark: "#338454",
  green: "#7c9e50",
  greenLight: "#9cc566",
  orangeD: "#fa8803",
  pink: "#f05d87",
  purple: "#a73f76",
  redD: "#db374b",
  redLight: "#e48e98",
  shadow: "0.3rem 0.3rem 0.3rem #00000010",
  yellow: "#ffb800",
  yellowLight: "#ffdb7f",
};
export const transitions = {
  expandPanel: "100ms width ease-in-out",
};
export const sizes = {
  iconDefault: "1.3rem",
  imageHeightDefault: "16rem",
  listWidth: "1300px",
  sidebarWidth: "4.5rem",
  minBreakpoint: "50rem",
  schedulerMaxWidth: "1700px",
  sidepanelWidth: "48rem",
};
export const borders = {
  placeholder: `1px solid transparent`,
  error: `1px solid ${colors.redD}`,
  standard: `1px solid ${colors.grayE}`,
};
export const backgroundHighlights = {
  active: {
    dark: "rgba(255,255,255,0.3)",
    medium: "rgba(0,0,0,0.3)",
    light: "rgba(0,0,0,0.1)",
  },
  hover: {
    dark: "rgba(255,255,255,0.15)",
    medium: "rgba(0,0,0,0.15)",
    light: "rgba(0,0,0,0.05)",
  },
};
export const zIndex = {
  schedulerDecoy: 100,
  floatingSearchButton: 800,
  schedulerHeader: 900,
  toaster: 1000,
  sidebar: 1050,
  cabinet: 1100,
  drawer: 1200,
  overlay: 1300,
  modal: 1400,
  dropDown: 1500,
  imageSlide: 1600,
  validationException: 1600,
};

export const SchedulerTextColors = {
  archived: colors.gray1,
  canceled: colors.gray1,
  complete: colors.gray1,
  inprogress: colors.grayF,
  late: colors.grayF,
  ready: colors.grayF,
  unassigned: colors.gray1,
  waiting: colors.grayF,
};

export const SchedulerHighlightColors = {
  archived: colors.gray6,
  canceled: colors.gray6,
  complete: colors.gray6,
  inprogress: colors.white,
  late: colors.white,
  ready: "#c4f0e5",
  unassigned: colors.white,
  waiting: colors.black,
};

export const SchedulerColors = {
  archived: "#cdd7d7",
  canceled: "#cdd7d7",
  complete: "#cdd7d7",
  inprogress:
    "linear-gradient(135deg, #073937 25%, #39615f 25%, #39615f 50%, #073937 50%, #073937 75%, #39615f 75%, #39615f 100%)",
  late: "#e47c02",
  ready: "#39615f",
  unassigned: "#f9be25",
  waiting:
    "linear-gradient(135deg, #aa9e5e 25%, #f9be25 25%, #f9be25 50%, #aa9e5e 50%, #aa9e5e 75%, #f9be25 75%, #f9be25 100%)",
};

export const SchedulerShadows = {
  archived: "#9cb0af",
  canceled: "#9cb0af",
  complete: "#9cb0af",
  inprogress: "#073937",
  late: "#fc5d2b",
  ready: "#073937",
  unassigned: "#cb9c23",
  waiting: "#aa9e5e",
};
